import { removeStorageItem, setStorageItem } from './storage';

export const handleMouseEnter = (dataKey: string) => {
  setStorageItem('tooltipDataKey', dataKey);
};
export const handleMouseLeave = () => removeStorageItem('tooltipDataKey');
